module.exports = __webpack_public_path__ + "static/media/illuEuropraid2017_1_02_full.f3488976.png";